module.exports = "/_next/static/images/John-f3e910c7e1f28bf669ddb22cb301fb18.jpg";